import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import Handling_item_table from "./handling_item_table/Handling_item_table";
import Handling_item_Form from "./handling_item_Form/Handling_item_Form";

function Handling_item() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Handling Of Test Or Calibration Item" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
             Handling of test or calibration items is carried out with proper identification, protection, and traceability from receipt to disposal. Each item is checked, labeled, & stored under controlled conditions to prevent damage, contamination, or deterioration. Any abnormalities are documented & communicated immediately. These practices ensure reliable results in accordance with ISO/IEC 17025:2017.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          <Handling_item_Form />
        </div>

        <div className="imperiality_table_div">
          <Handling_item_table />
        </div>

       
      </section>
    </>
  );
}

export default Handling_item;
